import React from 'react';
import SalesDocumentEditor from '@/pages/SalesDocuments/SalesDocumentEditor';
import { QUOTATION } from '@/pages/SalesDocuments/documentTypes';

export default function QuotationEditorPage() {
  return <SalesDocumentEditor docType={QUOTATION} />;
}
